export default {
  '/kanban/kanban': '/kanban/list',
  '/kanban/kanban-list': '/kanban/list',
  '/kanban/kanban-share': '/kanban/share',
  '/backlog/backlog-list': '/backlog/list',
  '/epic/epic-list': '/epic/list',
  '/project/project-list': '/project/list',
  '/project/project-setting': '/project/member',
  '/setting/setting-list': '/setting/fields',
  '/setting/list': '/setting/fields',
  '/setting/ApiManagement': '/setting/api',
  '/setting/IntegrationType': '/setting/integration',
  '/setting/integrations': '/setting/integration',
  '/setting/gitHub': '/setting/integration/github',
  '/setting/gitLab': '/setting/integration/gitlab',
  '/setting/jenkins': '/setting/integration/jenkins',
  '/setting/lark': '/setting/integration/lark',
  '/setting/weCom': '/setting/integration/we-com',
  '/setting/zoom': '/setting/integration/zoom',
  '/setting/integrations/github': '/setting/integration/github',
  '/setting/integrations/gitlab': '/setting/integration/gitlab',
  '/setting/integrations/jenkins': '/setting/integration/jenkins',
  '/setting/integrations/lark': '/setting/integration/lark',
  '/setting/integrations/we-com': '/setting/integration/we-com',
  '/setting/integrations/zoom': '/setting/integration/zoom',
  '/setting/subscriptionsMana': '/setting/subscription',
  '/setting/messageSetting': '/setting/notification',
  '/setting/personnel/InviteMemberList': '/setting/members',
  '/setting/personnel/invite-member-list': '/setting/members',
  '/setting/members/personnel-apply-list': '/setting/members',

  '/home': '/dashboard',
  '/teams': '/team',
  '/project/project-overview': '/project/overview',
  '/project/issue-type': '/project/worktype',
  '/project/function-switch': '/project/features',
  '/project/smart-assistant': '/project/automation',
  '/project/usage-logs': '/project/log',
  '/project/labels': '/project/tags',
  '/project/project-jenkins': '/project/cicd',
  '/setting/language': '/setting/workingdays',
  '/setting/info': '/setting/orginfo',
  '/setting/personnel': '/setting/members',
  '/setting/permission-assignment': '/setting/permission',
  '/setting/subscriptions': '/setting/subscription',
  '/setting/order-list': '/setting/billing',
  '/setting/personal-centre': '/setting/account',
  '/setting/personal-api': '/setting/api-key',

  '/issue/list': '/work/list',
  '/issue/table': '/work/table'
  // '/epic/list': '/project/gantt'
};
